<template>
  <div
    class="asc-report-export-wrapper"
    data-automation-id="wrapper_report_export"
  >
    <asc-accordion :value="1">
      <asc-accordion-item>
        <template slot="header">
          <asc-section-header title="Export"></asc-section-header>
        </template>
        <asc-accent-button
          button-text="Export to Excel"
          :on-click="onExportReport"
          :disabled="!isExportButtonsEnabled"
        ></asc-accent-button>
      </asc-accordion-item>
    </asc-accordion>
  </div>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscAccordion from '@/components/atoms/AscAccordion'
import AscAccordionItem from '@/components/atoms/AscAccordionItem'
import AscSectionHeader from '@/components/atoms/AscSectionHeader'
import AppFeatureFlags from '@/utilities/appFeatureFlags'

export default {
  name: 'AscReportExportWrapper',

  components: {
    AscAccentButton,
    AscAccordion,
    AscAccordionItem,
    AscSectionHeader,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    onExportReport: {
      type: Function,
      required: true,
    },
  },

  computed: {
    isExportButtonsEnabled() {
      return !this.loading && AppFeatureFlags.getReportDetailsExport()
    },
  },
}
</script>

<style lang="scss">
.asc-report-export-wrapper {
  background-color: $primary-white;
  margin-bottom: 16px !important;

  .asc-accent-button {
    width: 100%;
  }
}
</style>
